import api from "./axios";
import getEndpoint from "./endpoints";
import {
  CountryDetails,
  CountryDetailsResponse,
} from "@/types/server/country-details";

/** Details of one country by its slug, e.g. "united-arab-emirates". */
export async function getCountryDetails(
  country: string,
): Promise<CountryDetails> {
  const res = await api.get<CountryDetailsResponse>(
    getEndpoint("country-details"),
    { params: { country } },
  );
  return res.data.data;
}

/** Turns the "[lat,lng]" text into numbers, or null when it is not valid. */
export function parseCountryCoordinate(
  coordinate?: string | null,
): { lat: number; lng: number } | null {
  if (!coordinate) return null;
  try {
    const [lat, lng] = JSON.parse(coordinate);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    return { lat, lng };
  } catch {
    return null;
  }
}
